import { LoadingOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Button } from 'antd'
import React from 'react'
import { isEmpty, isLoaded } from 'react-redux-firebase'
import './AdminScreen.css'

type AdminScreenProps = {
  auth: any
  tenant: string
  onLogin(param: { provider: string; type: string }): void
  onLogout(): void
}

class AdminScreen extends React.Component<AdminScreenProps, any> {
  handleSignInClick = () => {
    this.props.onLogin({ provider: 'google', type: 'redirect' })
  }

  render() {
    const { auth, onLogout } = this.props

    if (isEmpty(auth)) {
      return (
        <div className="AdminScreen">
          {!isLoaded(auth) ? (
            <LoadingOutlined />
          ) : (
            <React.Fragment>
              <h3>Not signed in</h3>
              <div className="actions">
                <Button onClick={this.handleSignInClick}>Sign In</Button>
                <Button href="/">Back to App</Button>
              </div>
            </React.Fragment>
          )}
        </div>
      )
    }

    return (
      <div className="AdminScreen">
        <h3>Logged in as</h3>
        <div className="user">
          {auth.photoURL ? <Avatar size={'small'} src={auth.photoURL} /> : <UserOutlined />}
          <div className="name">{auth.displayName}</div>
        </div>
        <div className="actions">
          <Button onClick={onLogout}>Sign out</Button>

          <Button href="/">Continue to App</Button>
        </div>
      </div>
    )
  }
}

export default AdminScreen



// WEBPACK FOOTER //
// ./src/components/AdminScreen.tsx